import { matchPath } from "react-router-dom";

export function usesRedesignedSettingsControls(pathname: string): boolean {
  const settingsPath = matchPath("/stores/:storeId/settings/*", pathname)
    ?.params["*"];
  if (!settingsPath) {
    return false;
  }

  if (
    settingsPath === "order-management" ||
    settingsPath.startsWith("order-management/")
  ) {
    return !["returns-centers"].some(
      (section) =>
        settingsPath === `order-management/${section}` ||
        settingsPath.startsWith(`order-management/${section}/`),
    );
  }

  return [
    "oms/scanning-warehouse",
    "oms/security",
    "oms/warehouse-dashboard",
    "inventory-management",
  ].some(
    (route) => settingsPath === route || settingsPath.startsWith(`${route}/`),
  );
}
